import dynamic from 'next/dynamic';

const FooterCard = dynamic(() => import('./FooterCard'));
const JobDescriptionCard = dynamic(() => import('./JobDescriptionCard'));
const Header = dynamic(() => import('./Header'));
const Navbar = dynamic(() => import('./Navbar'));
const NavbarVendor = dynamic(() => import('./Navbar/NavbarVendor'));
const Footer = dynamic(() => import('./Footer'));
const NoJobsScreen = dynamic(() => import('./NoJobsScreen'));
const NoDataView = dynamic(() => import('./NoDataView'));
const FilterForm = dynamic(() => import('./FilterForm'));

import { Address, SocialMediaLinks, Careers, Blogs } from './OrgCard';

export { Header, Navbar, NavbarVendor, Footer, FooterCard, Address, SocialMediaLinks, Careers, JobDescriptionCard, NoDataView, Blogs, NoJobsScreen, FilterForm };
